import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import SmallInput from "../../components/smallInput/smallInput.component";
import {
  setSizeHeight,
  setSizeLength,
  setSizeWidth,
} from "../../redux/newRequest/newRequest.actions";
import {
  selectNewRequestSizes_height,
  selectNewRequestSizes_length,
  selectNewRequestSizes_width,
} from "../../redux/newRequest/newRequest.selectors";

const Size = ({
  selectNewRequestSizes_length,
  selectNewRequestSizes_width,
  selectNewRequestSizes_height,

  setSizeHeight,
  setSizeLength,
  setSizeWidth,
}) => {
  return (
    <div className="d-flex align-items-center justify-content-between mt-3">
      <div className="font-weight-bold ml-2" style={{ minWidth: "38px" }}>
        ابعاد بار
      </div>
      <SmallInput
        placeHolder="طول"
        label="متر"
        setTheState={setSizeLength}
        selectTheState={selectNewRequestSizes_length}
      />
      <SmallInput
        placeHolder="عرض"
        label="متر"
        className="mx-3"
        setTheState={setSizeWidth}
        selectTheState={selectNewRequestSizes_width}
      />
      <SmallInput
        placeHolder="ارتفاع"
        label="متر"
        setTheState={setSizeHeight}
        selectTheState={selectNewRequestSizes_height}
      />
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  selectNewRequestSizes_height: selectNewRequestSizes_height,
  selectNewRequestSizes_width: selectNewRequestSizes_width,
  selectNewRequestSizes_length: selectNewRequestSizes_length,
});

const mapDispatchToProps = (dispatch) => ({
  setSizeHeight: (x) => dispatch(setSizeHeight(x)),
  setSizeLength: (x) => dispatch(setSizeLength(x)),
  setSizeWidth: (x) => dispatch(setSizeWidth(x)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Size);
